//dependencias
import React, { Component } from 'react';

//componentes
import InformeingresoAction from './Informeingreso'

class Informei extends Component {

    render(){
        return(
            <div>
                <InformeingresoAction />
            </div>
        );
    }

}
export default Informei;